var SESSION_COUNTED_KEY = 'rubriq_trial_session_counted';
var SESSION_COUNT_KEY = 'rubriq_trial_session_count';
var DISMISSED_KEY = 'rubriq_trial_conversion_modal_dismissed';
export var TRIAL_CONVERSION_MODAL_SESSION = 2;
var read = function read(store, key) {
  try {
    return window[store].getItem(key);
  } catch (e) {
    return null;
  }
};
var write = function write(store, key, value) {
  try {
    window[store].setItem(key, value);
  } catch (e) {
    /* empty */
  }
};
export var trialSessionKey = function trialSessionKey(_ref) {
  var userIdentity = _ref.userIdentity,
    trialExpirationDate = _ref.trialExpirationDate;
  return userIdentity && trialExpirationDate ? "".concat(userIdentity, ":").concat(trialExpirationDate) : null;
};
export var countTrialSession = function countTrialSession(trialKey) {
  if (!trialKey) {
    return null;
  }
  var stored;
  try {
    stored = JSON.parse(read('localStorage', SESSION_COUNT_KEY));
  } catch (e) {
    stored = null;
  }
  var sessionCount = stored && stored.trialKey === trialKey ? stored.sessionCount : 0;
  if (read('sessionStorage', SESSION_COUNTED_KEY) === trialKey) {
    return sessionCount;
  }
  var updatedCount = sessionCount + 1;
  write('localStorage', SESSION_COUNT_KEY, JSON.stringify({
    trialKey: trialKey,
    sessionCount: updatedCount
  }));
  write('sessionStorage', SESSION_COUNTED_KEY, trialKey);
  return updatedCount;
};
export var isTrialConversionModalDismissed = function isTrialConversionModalDismissed(trialKey) {
  return read('sessionStorage', DISMISSED_KEY) === trialKey;
};
export var dismissTrialConversionModal = function dismissTrialConversionModal(trialKey) {
  return write('sessionStorage', DISMISSED_KEY, trialKey);
};